import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-protocol-widget',
  templateUrl: './protocol-widget.component.html',
  styleUrls: ['./protocol-widget.component.scss']
})
export class ProtocolWidgetComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
